export const TextFieldRules = {
  REQUIRED: (value: string) => !!value || 'Pflichtfeld.',
  TEXT: (value: string) => value === '' || 'Pflichtfeld.',
  EMAIL: (value: string) => {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Email Adresse nicht gültig'
  },
  LINK: (value: string) => {
    const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gim
    return pattern.test(value) || 'Link nicht gültig.'
  },
  PASSWORD: (value: string) =>
    value.length >= 6 || 'Das Passwort muss mindestens sechs Zeichen haben.'
}

export const MaxLengthValidator = {
  TEXT_FIELD: 50,
  EMAIL: 75
}

export const UserRole = {
  USER: 'user',
  ADMIN: 'admin',
  SUPERADMIN: 'superadmin',
  PARTNER: 'partner'
}

export const CategoryType = {
  LOCAL: 'local',
  ONLINE: 'e_commerce'
}

export const CompanyType = {
  LOCAL: 'local',
  ONLINE: 'e_commerce'
}

export const DiscountType = {
  RELIEF: 'relief',
  DISCOUNT: 'discount',
  PERCENTAGE: 'percentage',
  FREEITEMS: 'free_items',
  GOODIES: 'goodies',
  COUPON: 'coupon',
  INFO: 'info'
}

export const DealMediaType = {
  IMAGE: 'image',
  VIDEO: 'video'
}

export const DealCardType = {
  ECOMMERCE: 'e_commerce',
  LOCAL: 'local',
  SPECIFIC: 'specific',
  URL: 'url'
}

export const DealType = {
  ECOMMERCE: 'e_commerce',
  LOCAL: 'local',
  REWARDS: 'rewards'
}

export const DealTypeText: { [k: string]: string } = {
  ECOMMERCE: 'Onlineshops',
  LOCAL: 'Lokale Deals',
  REWARDS: 'Belohnung'
}

export const DealStatus = {
  DRAFT: 'draft',
  REVIEW_PENDING: 'review_pending',
  REVIEWED: 'reviewed',
  CHANGES_PENDING: 'changes_pending',
  APPROVED: 'approved',
  PAUSED: 'paused',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  DELETED: 'deleted'
}

export const RewardType = {
  INVITE: 'invite'
}

export const RedemptionType = {
  NONE: 'none',
  SINGLE_IN: 'single_in',
  MULTI_IN: 'multi_in',
  SINGLE_OUT: 'single_out',
  MULTI_OUT: 'multi_out'
}

export const Gender = {
  FEMALE: 0,
  MALE: 1,
  NEUTRAL: 2
}

export const GenderText: { [k: string]: string } = {
  FEMALE: 'Weiblich',
  MALE: 'Männlich',
  NEUTRAL: 'Divers'
}

export const SocialLoginType = {
  APPLE: 'apple',
  FACEBOOK: 'facebook',
  GOOGLE: 'google'
}
